// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__21k-Y","left":"StickyBox_left__1eXrE","right":"StickyBox_right__2ex7U"};